import prop from 'ramda/src/prop'
import { apiStoreLenses } from 'root/src/client/logic/api/lenses'
import currentRouteObj from 'root/src/client/logic/route/selectors/currentRouteObj'
import isEmpty from 'ramda/src/isEmpty'
import { allKey } from 'root/src/shared/constants/keys'
import { dashboardConstants } from 'root/src/shared/dashboard/dashboard.constants'

const { viewGraphsData, viewCreator, viewClip, viewListProcessing } = apiStoreLenses

export default (state) => {
	const {
		routeParams,
	} = currentRouteObj(state)

	// Handling for aggregated data
	const recordIdMod = isEmpty(routeParams) ? allKey : routeParams.recordId
	const listProcessing = viewListProcessing(state)

	const graphsData = prop(recordIdMod, viewGraphsData(state))
	const creatorsData = viewCreator(state)
	const clipsData = viewClip(state)
	const listEntries = Object.entries(listProcessing || {})
	const isClipsDataLoading = Boolean(listEntries.find(([key]) => key.includes(dashboardConstants.GET_DASHBOARD_DELIVERIES))?.at(1) ?? true)
	const isCreatorsDataLoading = Boolean(listEntries.find(([key]) => key.includes(dashboardConstants.GET_DASHBOARD_CREATORS))?.at(1) ?? true)
	const isGraphDataLoading = typeof graphsData === 'undefined'
	return {
		graphsData,
		creatorsData,
		clipsData,
		isClipsDataLoading,
		isCreatorsDataLoading,
		isGraphDataLoading,
	}
}
